"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormatterType = void 0;
var config_1 = require("../config/config");
var TimeUtil_1 = require("./TimeUtil");
var DateFormatterType;
(function (DateFormatterType) {
    DateFormatterType["DateFormat"] = "DateFormat";
    DateFormatterType["DateTimeFormat"] = "DateTimeFormat";
    DateFormatterType["TimeFormat"] = "TimeFormat";
})(DateFormatterType = exports.DateFormatterType || (exports.DateFormatterType = {}));
var DateTimeFormatter = /** @class */ (function () {
    function DateTimeFormatter() {
        var _this = this;
        this.dateFormatterTypeToString = function (key) { return DateFormatterType[key]; };
        this.dateFormatterTypeFromString = function (key) {
            switch (key) {
                case "DateFormat":
                    return DateFormatterType.DateFormat;
                case "DateTimeFormat":
                    return DateFormatterType.DateTimeFormat;
                case "TimeFormat":
                    return DateFormatterType.TimeFormat;
                default:
                    return undefined;
            }
        };
        this.getDateFormat = function (key) {
            var _a;
            switch ((_a = config_1.react_core_config.internalConfig.dateFormatter) === null || _a === void 0 ? void 0 : _a[key]) {
                case DateFormatterType.DateFormat:
                    return config_1.react_core_config.defaultDateFormat();
                case DateFormatterType.TimeFormat:
                    return config_1.react_core_config.defaultTimeFormat();
                case DateFormatterType.DateTimeFormat:
                    return config_1.react_core_config.defaultDateTimeFormat();
                case undefined:
                default:
                    return config_1.react_core_config.defaultDateTimeFormatFallback();
            }
        };
        this.getFormattedDateFromDateString = function (key, date) { return TimeUtil_1.formatDateString(date, _this.getDateFormat(key)); };
        this.getFormattedDateFromMoment = function (key, date) { return TimeUtil_1.formatMomentDate(date, _this.getDateFormat(key)); };
        this.getFormattedDateFromTimeStamp = function (key, timestamp) { return TimeUtil_1.formatTimeStamp(timestamp, _this.getDateFormat(key)); };
        this.getFormattedDateFromCurrentTime = function (key) { return TimeUtil_1.formatCurrentTime(_this.getDateFormat(key)); };
    }
    return DateTimeFormatter;
}());
var dateTimeFormatter = new DateTimeFormatter();
exports.default = dateTimeFormatter;
//# sourceMappingURL=DateTimeFormatter.js.map